export default __webpack_public_path__ + "2e21c72d32841df52b7215b4c6f4a8d6.png";